import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Route from "./layouts/route.jsx";
import useDomainStore from "./stores/domainStore.ts";

function App() {
  // Khởi tạo domain store khi app khởi động
  useEffect(() => {
    useDomainStore.getState().initializeDomain();
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        <Route />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#363636",
              color: "#fff",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
